import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";

const SubGroupDataList = () => {
  const { subgroupId, groupId } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const navigate = useNavigate();
  const token = getCookie("token");
  const userid = getCookie("userid");

  // Fetch SubGroup Data using Search API
  const fetchSubGroupData = async (page = 0) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://api.dqr-display-tms.eventum.co.in/api/SubGroupDataOperation/Search",
        {
          subgroupid: parseInt(subgroupId),
          ispageload: false,
          pagesize: pageSize,
          currentpageno: page,
          withoutpagination: false,
          pagedirection: "first",
        },
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
            accept: "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setData(response.data.data);
        setMessage("");
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching subgroup data:", error);
      setMessage("Failed to fetch data");
      setMessageType("error");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (subgroupId && token && userid) {
      fetchSubGroupData(currentPage);
    }
  }, [subgroupId, groupId, token, userid, pageSize, currentPage]);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        const res = await axios.post(
          "https://api.dqr-display-tms.eventum.co.in/api/SubGroupDataOperation/Delete",
          { id: id },
          {
            headers: {
              "X-Authorization": token,
              UserId: userid,
              "Content-Type": "application/json-patch+json",
              accept: "text/plain",
            },
          }
        );

        if (
          res.data &&
          (res.data.isresponse === true ||
            res.data.responsestatus === "SUCCESS")
        ) {
          setMessage("Record deleted successfully!");
          setMessageType("success");
          fetchSubGroupData(currentPage); // Refresh data
        } else {
          setMessage(
            res.data?.errormsg || res.data?.message || "Failed to delete record"
          );
          setMessageType("error");
        }
      } catch (error) {
        console.error("Error deleting record:", error);
        setMessage(
          error.response?.data?.errormsg ||
            error.response?.data?.message ||
            error.message ||
            "Failed to delete record"
        );
        setMessageType("error");
      }
    }
  };

  // Handle Add New Data
  const handleAddData = () => {
    navigate(`/subgroupdataadd/${subgroupId}/${groupId}`);
  };

  // Clear message after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h1 className="mb-0">SubGroup Data List</h1>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-success mr-2"
                    onClick={handleAddData}
                  >
                    <i className="fas fa-plus mr-1"></i>Add SubGroup Data
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate(`/subgroupdata/${subgroupId}/${groupId}`)}
                  >
                    <i className="fas fa-arrow-left mr-1"></i>Back
                  </button>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="d-flex justify-content-between align-items-center">
                        <h3 className="card-title">
                          Data Records ({data.length})
                        </h3>
                        <select
                          name="page-size"
                          id="page-size"
                          className="form-control"
                          style={{ width: "100px" }}
                          onChange={(e) => {
                            setPageSize(parseInt(e.target.value));
                            setCurrentPage(0);
                          }}
                          value={pageSize}
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>
                    </div>
                    <div className="card-body table-responsive p-0">
                      {loading ? (
                        <div className="text-center p-5">
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : data.length > 0 ? (
                        <table className="table table-hover table-striped table-sm">
                          <thead className="thead-light" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
                            <tr>
                              <th style={{
                                width: "3%",
                                className: "text-center",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>
                                #
                              </th>
                              <th style={{
                                width: "15%",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>POS Name</th>
                              <th style={{
                                width: "15%",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>Merchant ID</th>
                              <th style={{
                                width: "12%",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>Store ID</th>
                              <th style={{
                                width: "28%",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>Remark</th>
                              <th style={{
                                width: "10%",
                                className: "text-center",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>
                                Status
                              </th>
                              <th style={{
                                width: "17%",
                                className: "text-center",
                                backgroundColor: 'var(--surface2)',
                                color: 'var(--text)',
                                borderColor: 'var(--border)'
                              }}>
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((record, index) => (
                              <tr key={record.id || index}>
                                <td className="text-center">
                                  {currentPage * pageSize + index + 1}
                                </td>
                                <td>{record.posname || "-"}</td>
                                <td>{record.merchantid || "-"}</td>
                                <td>{record.storeid || "-"}</td>
                                <td>{record.remark || "-"}</td>
                                <td className="text-center">
                                  <span
                                    className={`badge ${record.active ? "badge-success" : "badge-danger"
                                      }`}
                                  >
                                    {record.active ? "Active" : "Inactive"}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <div className="btn-group btn-group-sm">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() =>
                                        navigate(
                                          `/subgroupdataedit/${record.id}/${subgroupId}/${groupId}`
                                        )
                                      }
                                      title="Edit Record"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => handleDelete(record.id)}
                                      title="Delete Record"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-center p-5">
                          <p className="text-muted">No data found</p>
                        </div>
                      )}
                    </div>
                    <div className="card-footer">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
                        disabled={currentPage === 0}
                      >
                        <i className="fas fa-chevron-left mr-1"></i>Previous
                      </button>
                      <button
                        className="btn btn-outline-primary ml-2"
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={data.length < pageSize}
                      >
                        Next<i className="fas fa-chevron-right ml-1"></i>
                      </button>
                      <span className="ml-3 text-muted">
                        Page {currentPage + 1}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Message display */}
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "10px",
            width: "25%",
            zIndex: "9999",
          }}
        >
          <div
            className={`alert ${messageType === "success" ? "alert-success" : "alert-danger"
              } d-flex align-items-center`}
            role="alert"
            style={{ marginBottom: "10px" }}
          >
            <div>
              {messageType === "success" ? (
                <i className="fas fa-check-circle mr-2"></i>
              ) : (
                <i className="fas fa-exclamation-circle mr-2"></i>
              )}
              {message}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubGroupDataList;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

